<template>
    <div class="card mt-3">
        <div class="card-body">
            <h5 class="card-title">HTTP Details</h5>
            <http-server-form
                v-for="server in serverData.http.serverArr"
                :key="server.serverId"
                :server="server"
                @serverRemoved="removeServer($event)"></http-server-form>
            <button
                class="btn btn-sm float-right mt-3"
                @click="addServer"
                :disabled="serverData.ftp.serverArr.length >= 10 ? true : false">Add Server</button>
        </div>
    </div>
</template>

<script>
import HttpServerForm from './HttpServerForm.vue'

export default {
    components: {
        'http-server-form': HttpServerForm
    },
    props: ['serverData'],
    methods: {
        addServer() {
            this.$emit('serverAdded', 'http')
        },
        removeServer($event) {
            this.$emit('serverRemoved', {
                serverType: 'http',
                serverId: $event.serverId
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/HttpDetails.vue